// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contTimer{
    font-family: 'Share Tech Mono', monospace;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 10px;
}
.btn_reg_tour {
    font-family: 'Lato', sans-serif;
    background-image: linear-gradient(to right, #1A2980 0%, #26D0CE  51%, #1A2980  100%);
    margin: 10px;
    margin-top: 10px;
    padding: 10px 25px;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;

    border-radius: 10px;
    display: block;
}
.timeReg{
    color: #daf6ff;
    text-shadow: 0 0 20px rgba(10, 175, 230, 1),  0 0 20px rgba(10, 175, 230, 0);

    letter-spacing: 0.05em;
    font-size: 40px;
    padding: 5px 0;
}
.time {
    color: #daf6ff;
    text-shadow: 0 0 20px rgba(10, 175, 230, 1),  0 0 20px rgba(10, 175, 230, 0);

    letter-spacing: 0.05em;
    font-size: 60px;
    padding: 5px 0;
}

.btn_reg_tour:hover {
    background-position: right center; /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
}
.icoTg{
    margin-top: 10px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/Timer/Timer.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;IACzC,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;AACjB;AACA;IACI,+BAA+B;IAC/B,oFAAoF;IACpF,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,YAAY;;IAEZ,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,cAAc;IACd,4EAA4E;;IAE5E,sBAAsB;IACtB,eAAe;IACf,cAAc;AAClB;AACA;IACI,cAAc;IACd,4EAA4E;;IAE5E,sBAAsB;IACtB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iCAAiC,EAAE,4CAA4C;IAC/E,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".contTimer{\r\n    font-family: 'Share Tech Mono', monospace;\r\n    color: white;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    padding: 10px;\r\n}\r\n.btn_reg_tour {\r\n    font-family: 'Lato', sans-serif;\r\n    background-image: linear-gradient(to right, #1A2980 0%, #26D0CE  51%, #1A2980  100%);\r\n    margin: 10px;\r\n    margin-top: 10px;\r\n    padding: 10px 25px;\r\n    transition: 0.5s;\r\n    background-size: 200% auto;\r\n    color: white;\r\n\r\n    border-radius: 10px;\r\n    display: block;\r\n}\r\n.timeReg{\r\n    color: #daf6ff;\r\n    text-shadow: 0 0 20px rgba(10, 175, 230, 1),  0 0 20px rgba(10, 175, 230, 0);\r\n\r\n    letter-spacing: 0.05em;\r\n    font-size: 40px;\r\n    padding: 5px 0;\r\n}\r\n.time {\r\n    color: #daf6ff;\r\n    text-shadow: 0 0 20px rgba(10, 175, 230, 1),  0 0 20px rgba(10, 175, 230, 0);\r\n\r\n    letter-spacing: 0.05em;\r\n    font-size: 60px;\r\n    padding: 5px 0;\r\n}\r\n\r\n.btn_reg_tour:hover {\r\n    background-position: right center; /* change the direction of the change here */\r\n    color: #fff;\r\n    text-decoration: none;\r\n}\r\n.icoTg{\r\n    margin-top: 10px;\r\n    cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
